import React, { Component } from "react";
import { compose } from "recompose";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
const styles = (theme) => ({});

class CloneErrorDialog extends Component {
  render() {
    const { cloneErrors, handleCloseCloneError } = this.props;
    return (
      <Dialog
        open={cloneErrors.length > 0}
        onClose={handleCloseCloneError}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Error</DialogTitle>
        <DialogContent>
          <List component="nav">
            {cloneErrors.map((error) => (
              <ListItem key={`clone-error-${error}`} item>
                <ListItemText
                  primary={<span style={{ color: "red" }}>{error}</span>}
                />
              </ListItem>
            ))}
          </List>
        </DialogContent>
      </Dialog>
    );
  }
}

CloneErrorDialog.propTypes = {
  theme: PropTypes.object.isRequired,
  cloneErrors: PropTypes.array.isRequired,
  handleCloseCloneError: PropTypes.func.isRequired,
};

export default compose(
  withStyles(styles, {
    name: "CloneErrorDialog",
    withTheme: true,
  }),
)(CloneErrorDialog);
